<template>
  <li class="translation-item py-2">

    <h5 class="d-flex justify-content-between align-items-center">
      <span :class="{'forced-ske': ske}">
        {{ name }}

        <span v-if="showAutotranslated && (is_autotranslated == true || is_autotranslated == '1')" class="auto-badge p-1 px-2 ml-2">
          Auto translated
        </span>
      </span>
      
      <svg xmlns="http://www.w3.org/2000/svg" class="close" :class="{'forced-ske': ske}" width="20" height="20" viewBox="0 0 20 20" fill="currentColor" @click.prevent.stop="$emit('remove')">
        <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
      </svg>
    </h5>
    <span :class="{'forced-ske': ske}">
      {{ language }}
    </span>
    <p class="mb-0" :class="{'forced-ske': ske}">
      {{ short_description }}
    </p>
    
  </li>
</template>

<script>

import table from "src/mixins/tableFieldOptions"

export default {
  mixins: [table],
  props: {
    ske: Boolean,
    showAutotranslated: Boolean,

    is_autotranslated: {
      type: [Boolean, String],
      required: false,
    },
    lang: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
    short_description: {
      type: String,
      required: false,
    },
  },
  computed: {
    language() {
      const lang = this.lang
      const option = this.translationOptions && this.translationOptions.find(item => item.value === lang)
      return option && option.str
    },
  },
}

</script>

<style scoped>

li {
  list-style-type: none;
  cursor: pointer;
  transition-duration: .15s;
}

li:hover {
  background-color: rgb(250,250,250);
}

li + li {
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.auto-badge {
  color: #065F46;
  background-color: #D1FAE5;
  border-radius: 1px;
}

h5 {
  margin: none;
  color: #212529;
  font-size: 1.09em;
  font-weight: 600;
  margin: 0;
  margin-bottom: 2px;
}

p {
  color: rgba(0,0,0, .5);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.close {
  color: #9A9A9A;
}

.close:hover {
  color: #FF4A55; 
}

</style>
